module.exports = __webpack_public_path__ + "img/arr_words.18708fb8.svg";